<template>
  <div class="categoryLearn">
    <div class="content-categoryLearn">
      <h6>
        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده
        از طراحان گرافیک است.
      </h6>
      <p><v-icon>mdi-tree</v-icon>خودآگاهی:</p>
      <ul>
        <li>لورم ایپسوم متن ساختگی</li>
        <li>لورم ایپسوم متن ساختگی</li>
        <li>لورم ایپسوم متن ساختگی</li>
      </ul>
      <p><v-icon>mdi-tree</v-icon>خودآگاهی:</p>
      <ul>
        <li>لورم ایپسوم متن ساختگی</li>
        <li>لورم ایپسوم متن ساختگی</li>
        <li>لورم ایپسوم متن ساختگی</li>
      </ul>
      <p><v-icon>mdi-tree</v-icon>خودآگاهی:</p>
      <ul>
        <li>لورم ایپسوم متن ساختگی</li>
        <li>لورم ایپسوم متن ساختگی</li>
        <li>لورم ایپسوم متن ساختگی</li>
      </ul>
      <p><v-icon>mdi-tree</v-icon>خودآگاهی:</p>
      <ul>
        <li>لورم ایپسوم متن ساختگی</li>
        <li>لورم ایپسوم متن ساختگی</li>
        <li>لورم ایپسوم متن ساختگی</li>
      </ul>
    </div>
    <div class="btns-categoryLearn">
      <router-link to="meeting" class="btn-view">
        <span>مشاهده جلسات</span>
      </router-link>
      <router-link to="payment" class="btn-payment">
        <span> پرداخت کامل 270هزارتومان</span>
      </router-link>
      <router-link to="opinionuser" class="btn-opinion">
        <span> تجربه شرکت کنندگان</span>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "categoryLearn",
};
</script>
<style>
.categoryLearn {
  background-image: url("../../assets/image/background.jpg");
  height: 100%;
  position: relative;
  background-size: cover;
  padding: 0;
  z-index: 10;
  overflow: auto;
}
.content-categoryLearn {
  height: 80vh;
  overflow: auto;
  background: rgba(255, 255, 255, 0.5);
  margin: 0 15px;
   margin-top: 60px;
  padding: 25px 20px;
}
.content-categoryLearn h6 {
  font-size: 15px;
  font-weight: 100;
  padding: 10px;
}
.content-categoryLearn p {
  font-size: 15px;
  padding-right: 10px;
  padding-top: 15px;
}
.content-categoryLearn ul li {
  font-size: 14px;
  padding-right: 40px;
  line-height: 2;
}
.btns-categoryLearn .btn-view,
.btns-categoryLearn .btn-payment,
.btns-categoryLearn .btn-opinion {
  align-items: center;
  display: flex;
  color: #fff;
  margin: 15px 10px;
  font-size: 13px;
}

.btns-categoryLearn {
  display: flex;
  position: absolute;
  bottom: 25px;
}
.btns-categoryLearn .btn-view {
  background: #0000cd;
  border-radius: 5px;
}
.btns-categoryLearn .btn-payment {
  background: #50ac17;
  border-radius: 5px;
}
.btns-categoryLearn .btn-opinion {
  background: #8f14c4;
  border-radius: 5px;
}
.btns-categoryLearn a span {
  display: flex;
  text-align: center;
  padding: 10px;
}
</style>
